var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0126 0.569824C4.49108 0.569824 0 5.02376 0 10.4996C0 15.9754 4.49108 20.4304 10.0126 20.4304C15.5341 20.4304 20.0262 15.9754 20.0262 10.4996C20.0262 5.02376 15.5341 0.569824 10.0126 0.569824ZM10.0126 19.6358C4.93415 19.6358 0.801218 15.537 0.801218 10.5006C0.801218 5.46418 4.93415 1.36441 10.0126 1.36441C15.091 1.36441 19.226 5.46215 19.226 10.5006C19.226 15.5391 15.093 19.6358 10.0126 19.6358Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3682 10.5006C16.3682 11.0425 15.9251 11.4819 15.3776 11.4819H4.64573C4.09829 11.4819 3.65625 11.0425 3.65625 10.5006C3.65625 9.95869 4.09829 9.51929 4.64573 9.51929H15.3776C15.9251 9.51929 16.3682 9.95869 16.3682 10.5006Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0129 4.19653C10.5604 4.19653 11.0024 4.63594 11.0024 5.17886V15.822C11.0024 16.3649 10.5604 16.8033 10.0129 16.8033C9.4665 16.8033 9.02344 16.3659 9.02344 15.822V5.17886C9.02344 4.63594 9.4665 4.19653 10.0129 4.19653Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.28a2cdc79845d4bf2a469012272e1f8b.svg";
export { ForwardRef as ReactComponent };